import { render, staticRenderFns } from "./DocumentFilesContainer.vue?vue&type=template&id=df35db8a&"
import script from "./DocumentFilesContainer.vue?vue&type=script&lang=js&"
export * from "./DocumentFilesContainer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFilesContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports